const _ = require('lodash');

const Performance = (app) => {
  const table = () => {
    const marks = performance.getEntriesByType('mark');
    console.table(marks);
  };

  const getStyles = (color) => {
    return _.map({
      'background': `rgba(${color}, 0.1)`,
      'border': `1px solid rgba(${color}, 1)`,
      'border-left': `10px solid rgba(${color}, 1)`,
      'padding': '10px'
    }, (val, key) => `${key}: ${val}`).join(';');
  };

  const getMark = (name) => {
    return _.last(_.filter(performance.getEntriesByType('mark'), (mark) => {
      return mark.name.indexOf(name) >= 0;
    }));
  };

  const getMeasure = (markFrom, markTo) => {
    const measurements = performance.getEntriesByType('measure');
    const match = `configure:measure:from:${markFrom.name}:to:${markTo.name}`;

    return _.head(_.filter(measurements, (measure) => {
      return measure.name === match;
    }));
  };

  const showPerformance = () => app.mergedParams.showPerformance || app.mergedParams.showAnalytics;

  // I'm creating a wrapper function for performance.mark because currently
  // Chrome, Safari and Firefox all behave a little differently
  // This function will create and return a mark
  const mark = (name) => {
    const m = performance.mark(name);
    return (m) ? m : performance.getEntriesByName(name);
  };

  // Prep and send the data to Google Analytics
  const log = (category, variable, timing) => {
    if ( !timing ) {
      return;
    }

    const duration = Math.round(timing.duration || timing);

    if ( showPerformance() ) {
      const color = (duration < 500) ? '0, 255, 0' : (duration > 1500) ? '255, 0, 0' : '255, 255, 0';
      console.log(`%c${category} - ${variable}: ${duration} ms`, getStyles(color));
    }

    ga('Fluid.send', 'timing', category, variable, duration, app.mergedParams.product.toString());
  };

  // Helper method to know if the two events have completed
  const textRender = () => {
    const keyup = getMark('configure:ugc:start');
    const lastEnd = getMark('configure:model:rendered');

    if ( !lastEnd || _.isUndefined(keyup) ) {
      return false;
    }

    return performance.measure('ugc-upload', keyup.name, lastEnd.name).duration;
  };

  const cleanUp = () => {
    // Once the UGC has rendered we need to ensure we clean-up the marks that
    // we've defined. Every once and a while we'll get a ghost time logged that
    // is very and inaccurate in terms of performance. Deleting these marks
    // has so far prevented these ghosts.
    performance.clearMarks('configure:model:rendered');
    performance.clearMarks('configure:ugc:start');
    performance.clearMarks('configure:ugc:upload-image');
    performance.clearMarks('configure:ugc:success-callback');
  };

  const record = (category, variable, ...marks) => {
    _.forEach(marks, (mark) => {
      const markFrom = getMark(mark[0]) || {name: undefined};
      const markTo = getMark(mark[1]);
      let measure = performance.measure(`configure:measure:from:${markFrom.name}:to:${markTo.name}`, markFrom.name, markTo.name);

      // Firefox and Safari do not return anything when a measure is created.
      // In this case we need to explicitly go get it.
      if ( !measure ) {
        measure = getMeasure(markFrom, markTo);
      }

      log(category, variable, measure);
    });
  };

  const logConfigureLoaded = (category, variable, mark) => {
    const end = getMark(mark);
    log(category, variable, end.startTime);
  };

  const ugcSteps = () => {
    const ugcStart = getMark('configure:ugc:start');
    const upload = getMark('configure:ugc:upload-image');
    const callback = getMark('configure:ugc:success-callback');
    const render = getMark('configure:model:rendered');

    if ( !ugcStart || !upload || !callback || !render ) {
      return;
    }

    record('UGC', 'Text Entry to Upload', ['configure:ugc:start', 'configure:ugc:upload-image']);
    record('UGC', 'Upload to Callback', ['configure:ugc:upload-image', 'configure:ugc:success-callback']);
    record('UGC', 'Callback to Render', ['configure:ugc:success-callback', 'configure:model:rendered']);
    record('UGC', 'Upload Process', ['configure:ugc:start', 'configure:model:rendered']);

    cleanUp();
  };

  const resources = () => {
    const resources = performance.getEntriesByType('resource');
    const data = resources.map((r) => {
      const {
        duration,
        initiatorType,
        name
      } = r;

      const extension = name.split(/[#?]/)[0].split('.').pop().trim();

      return {
        duration,
        extension,
        initiatorType,
        name
      };
    });

    const perfData = performance.timing;

    return {
      byExtension: _.groupBy(data, 'extension'),
      byInitiatorType: _.groupBy(data, 'initiatorType'),
      data,
      timing: {
        connectTime: perfData.responseEnd - perfData.requestStart,
        pageLoadTime: perfData.loadEventEnd - perfData.navigationStart,
        renderTime: perfData.domComplete - perfData.domLoading
      }
    };
  };

  return {
    log,
    logConfigureLoaded,
    mark,
    record,
    resources,
    table,
    textRender,
    ugcSteps
  };
};

module.exports = Performance;